import { LOAD_LAST_ORDERS } from '../actions/types';


export default function (state = [], action) {

    switch (action.type) {
        case LOAD_LAST_ORDERS:
            return action.payload;
        default: return state;
    }
}
